import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ProductSelector } from "../../rawData/product/productSelector";
import { WarehouseSelector } from "../../rawData/warehouse/warehouseSelector";
import { CreateCodeConversionViewModel, lineItem } from "./createCodeConversion-viewModel"

export class CreateCodeConversionView extends View<CreateCodeConversionViewModel>{
    GetViewUniqueId(): string {
        return "V-809CDC1C-E18D-4A98-9328-827A9F9C2F93"
    }
    loadHtml(): string {
        let element = require('./createCodeConversion.html').default;
        let style = require('./createCodeConversion.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set sourceProductSearch(v: ProductSelector) { this._sourceProductSearch = v; } public get sourceProductSearch(): ProductSelector { return this._sourceProductSearch;} private _sourceProductSearch: ProductSelector;
    public set destinationProdudtSearch(v: ProductSelector) { this._destinationProdudtSearch = v; } public get destinationProdudtSearch(): ProductSelector { return this._destinationProdudtSearch;} private _destinationProdudtSearch: ProductSelector;
    public set sourceLineItems(v: ObservableArray<lineItem>) { this._sourceLineItems = v; } public get sourceLineItems(): ObservableArray<lineItem> { return this._sourceLineItems;} private _sourceLineItems: ObservableArray<lineItem>;
    public set destinationLineItems(v: ObservableArray<lineItem>) { this._destinationLineItems = v; } public get destinationLineItems(): ObservableArray<lineItem> { return this._destinationLineItems;} private _destinationLineItems: ObservableArray<lineItem>;
    public set sourceWarehouseSelector(v: WarehouseSelector) { this._sourceWarehouseSelector = v; } public get sourceWarehouseSelector(): WarehouseSelector { return this._sourceWarehouseSelector;} private _sourceWarehouseSelector: WarehouseSelector;
    public set destinationWarehouseSelector(v: WarehouseSelector) { this._destinationWarehouseSelector = v; } public get destinationWarehouseSelector(): WarehouseSelector { return this._destinationWarehouseSelector;} private _destinationWarehouseSelector: WarehouseSelector;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
 
    close() {
        this.dataContext.closePopup();
    }

    createTransfer(){
        this.dataContext.createTransfer();
    }
}
